<div class="gpd-tabbed-page">
  <nav class="gpd-page-tabs">
    <a *ngFor="let item of tabs" class="gpd-page-tab" [routerLink]="item.link" routerLinkActive="active" (click)="goto(item)">
      {{ item.text }}
    </a>
  </nav>
  <div class="gpd-tabbed-page-content">
    <router-outlet> </router-outlet>
  </div>
</div>